import { computed, Directive, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { hlm } from '@spartan-ng/ui-core';
import { cva, type VariantProps } from 'class-variance-authority';

import type { ClassValue } from 'clsx';

export const alertTitleVariants = cva('tw-mb-3 tw-leading-none tw-tracking-tight', {
    variants: {}
});
export type AlertTitleVariants = VariantProps<typeof alertTitleVariants>;

@Directive({
    selector: '[hlmAlertTitle]',
    standalone: true,
    host: {
        '[class]': '_computedClass()'
    }
})
export class HlmAlertTitleDirective {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected _computedClass = computed(() => sonaHlm(alertTitleVariants(), this.userClass()));
}
